import { Divider } from '@mui/material';
import type { PropsWithChildren } from 'react';
import React from 'react';

type FilterDrawerSectionProps = PropsWithChildren<{
  label: string;
}>;

export const FilterDrawerSection: React.FC<FilterDrawerSectionProps> = ({ children, label }) => {
  return (
    <section className="flex flex-col gap-y-3.5">
      <p className="text-sm">{label}</p>
      <Divider/>
      <div className="flex flex-wrap gap-2">
        {children}
      </div>
      <Divider/>
    </section>
  );
};